import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=3bb1ec8c&scoped=true&"
import script from "./HelpPage.vue?vue&type=script&lang=js&"
export * from "./HelpPage.vue?vue&type=script&lang=js&"
import style0 from "./HelpPage.vue?vue&type=style&index=0&id=3bb1ec8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb1ec8c",
  null
  
)

export default component.exports